import React from "react";
import Drawer from "@mui/material/Drawer";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaPaperPlane,
} from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import logoLight from "../assets/logo-light.png";
import "../App.css";

const SidebarOne = ({ isOpen, closeSidebar }) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={closeSidebar}
      PaperProps={{
        sx: { width: 300, backgroundColor: "transparent", boxShadow: "none" },
        className: "sidebar-one",
      }}
    >
      <div className="sidebar-one__overlay" onClick={closeSidebar}></div>

      <div className="sidebar-one__content">
        <div className="sidebar-one__close" onClick={closeSidebar}>
          <IoMdClose className="flaticon-close" />
        </div>

        <div className="sidebar-one__logo">
          <a href="/" aria-label="logo image">
            <img src={logoLight} alt="epaging" width="133" />
          </a>
        </div>

        <p className="sidebar-one__text">
          Mauris ut enim sit amet lacus ornare ullamcor...
        </p>

        <h4 className="sidebar-one__title">Contact Info:</h4>
        <ul className="sidebar-one__info">
          <li>
            <FaMapMarkerAlt /> B-2, PLOT NO.405/1/B, KCHS, Block-7/8, Karachi,
            Pakistan
          </li>
          <li>
            <FaEnvelope />{" "}
            <a href="mailto:info@epaging.net">info@epaging.net</a>
          </li>
          <li>
            <FaPhoneAlt /> <a href="tel:02134327000">(021) 343-27-000</a>
          </li>
        </ul>

        <div className="sidebar-one__social">
          <a href="https://www.facebook.com/ePAGING/" target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
            <span className="sr-only">Facebook</span>
          </a>
          <a href="https://twitter.com/epaging" target="_blank" rel="noopener noreferrer">
            <FaTwitter />
            <span className="sr-only">Twitter</span>
          </a>
          <a href="https://www.instagram.com/epagingpvtltd/" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
            <span className="sr-only">Instagram</span>
          </a>
          <a href="https://www.youtube.com/channel/UCRmgC5M_Z2eFAIk9w500sxg" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
            <span className="sr-only">Youtube</span>
          </a>
        </div>

        <h4 className="sidebar-one__title">Newsletter:</h4>
        <form action="#" className="sidebar-one__newsletter mc-form">
          <input type="text" name="EMAIL" placeholder="Email address" />
          <button type="submit">
            <FaPaperPlane />
            <span className="sr-only">submit</span>
          </button>
        </form>
      </div>
    </Drawer>
  );
};

export default SidebarOne;
